import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cmFTH from './_cmFTH';
import * as cr from './_cr';

import { a } from './_csAbt';
import * as gs from './_csGbl';
import * as l from './_csLcl';
import { useMsgz } from "./_csMdlMsg";
import { useLdrz } from "./_csLdr";

import * as BoxC from './_ccbBoxC';
import * as BtnC from './_cccBtnC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

let $eml = '';
let $code = '';

export const S = React.memo((pz: { // send code
  sPz: ht.dz,
  cz: {
    ccd?: ht.s,
    grtCfmz?: (_dz: ht.dz) => ht.dz,
    bfrSend: () => ht.b,
  }
}) => {

  const _frcUdt = l.frcUdt();
  const _gUserz = gs.useUserz();
  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();

  const _send = async () => {
    //hf.l(`LgnMailC 74: ${_gUserz.crt._dmn}, ${$eml}`)
    let _b1 = true;
    if (pz.cz.bfrSend) _b1 = await pz.cz.bfrSend();
    if (!_b1) return;
    _sLdrz.show();
    const _b2 = await hf.ectSrlAsync([
      async () => {
        let _b = true;
        if (
          !hf.f($eml)
        ) _b = false;
        if (!_b) {
          _sMsgz.show({
            textCz: {
              textz: {
                pfx: `メールアドレスを入力してください`
              }
            }
          })
        }
        return _b;
      },
    ])
    if (!_b2) {
      _sLdrz.hide();
      return;
    }
    else {
      await cmFTH.sendCodeAsync({
        dmn: _gUserz.crt._dmn,
        eml: $eml,
        ... pz.cz.grtCfmz ? pz.cz.grtCfmz({ eml: $eml }) : undefined, // $eml 以外のチェック条件 
      });
      _sLdrz.hide();
      pz.sPz.set({
        steps: [1],
        eml: $eml,
      });
      $code = '';
    }

  }

  return (
    cr.c(BoxC.N, {
      key: `LgnMail.S`,
      boxStlz: a('dw/f fd/ccc'),
      oClds: [

        cr.c(LblC.N, {
          key: -10,
          abtType: '_vclz',
          boxStlz: a('mb/4'),
          lblCz: {
            textz: {
              pfx: 'メールアドレス',
              stlz: a(`tc/${pz.cz?.ccd ?? 'lt9'}`),
            },
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                cz: {
                  bEdit: true,
                  bDrt: true,
                  iptType: 'text',
                  vle: $eml,
                  onChg: (_s: ht.s) => {
                    $eml = hf.cvtEml(_s);
                    _frcUdt();
                  }
                }
              })
            ],
          }
        }),

        cr.c(BtnC.N, {
          key: -20,
          abtType: 'nextCmnz',
          boxStlz: a(`sc/${pz.cz?.ccd ?? 'lt9'}`),
          lblCz: {
            textz: {
              pfx: '送る',
            }
          },
          pslPtyz: {
            onPress: _send,
          },
        }),

      ]
    })
  );
});

export const C = React.memo((pz: { // confirm code
  sPz: ht.dz,
  cz: {
    ccd: ht.s,
    grtCfmz?: (_dz: ht.dz) => ht.dz,
    atrCfm: (_10rz: ht.dz) => void,
  }
}) => {

  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();
  const _gUserz = gs.useUserz();

  React.useEffect(() => {
    $code = '';
    pz.sPz.udt();
  }, [
    pz.sPz.crt.step,
  ]);

  const _lgn = async () => {
    _sLdrz.show();
    const _b2 = await hf.ectSrlAsync([
      async () => {
        let _b = true;
        if (
          !hf.f($code)
        ) _b = false;
        if (!_b) {
          _sMsgz.show({
            textCz: {
              textz: {
                pfx: `確認コードを入力してください`
              }
            }
          })
        }
        return _b;
      },
    ])
    if (!_b2) {
      _sLdrz.hide();
      return;
    }
    const _dz = await cmFTH.cfmCodeAsync({
//      dmn: 0, // 管理用
      dmn: _gUserz.crt._dmn,
      eml: $eml,
      code: $code,
      ... pz.cz.grtCfmz ? pz.cz.grtCfmz({ eml: $eml }) : undefined,
    })
    //hf.l(`LgnMailC 132: ${hf.s(_dz)}`);
    if (_dz?.err) {
      //hf.l(`LgnMailC 134: here`);
      _sMsgz.show({
        textCz: {
          textz: {
            pfx: '認証に失敗しました',
          }
        }
      })
      _sLdrz.hide();
    }
    else {
      //hf.l(`LgnMailC 144: here`);
      await _gUserz.saveAsync({
        _10rz: _dz?._10rz,
      });
      //hf.l(`LgnMailC 149: here`);
      _sLdrz.hide();
      $eml = ''; $code = ''; // logout 時を考慮し初期化
      pz.cz.atrCfm(_dz?._10rz);
    }
  }

  return (
    cr.c(BoxC.N, {
      key: `LgnMail.C`,
      boxStlz: a('dw/f'),
      oClds: [

        cr.c(LblC.N, {
          key: -10,
          abtType: '_vclz',
          boxStlz: a('mb/4'),
          lblCz: {
            textz: {
              pfx: '確認コード',
              stlz: a(`tc/${pz.cz.ccd}`),
            },
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                cz: {
                  bEdit: true,
                  iptType: 'text',
                  vle: $code,
                  onChg: (_s: ht.s) => {
                    $code = _s;
                  }
                }
              })
            ],
          }
        }),

        cr.c(BoxC.N, {
          key: -20,
          boxStlz: a('dw/f dwx/120 fd/rac'), 
          oClds: [

            cr.c(BtnC.N, {
              key: -10,
              abtType: 'backCmnz',
              boxStlz: a('dw/18 mr/1'),
              lblCz: {
                textz: {
                  pfx: '前の画面に戻る',
                }
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [0],
                  })
                }
              },
            }),

            cr.c(BtnC.N, {
              key: -20,
              abtType: 'nextCmnz',
              boxStlz: a(`dw/18 sc/${pz.cz.ccd}`),
              lblCz: {
                textz: {
                  pfx: '送る',
                }
              },
              pslPtyz: {
                onPress: _lgn,
              },
            }),

          ]
        })
      ]
    })
  );
});
